export default class User {}
